import RozmowaCallResultCard from './RozmowaCallResultCard'
import RozmowaNextStepsSection from './RozmowaNextStepsSection'
import RozmowaSummarySection from './RozmowaSummarySection'
import RozmowaTranscriptSection from './RozmowaTranscriptSection'
import useRozmowaAnalysisPolling from './hooks/useRozmowaAnalysisPolling'

export default function RozmowaAnalysisSections({ rozmowa }) {
	const polledRozmowa = useRozmowaAnalysisPolling(rozmowa)

	return (
		<>
			<RozmowaCallResultCard rozmowa={polledRozmowa} />
			<RozmowaSummarySection rozmowa={polledRozmowa} />
			<RozmowaTranscriptSection rozmowa={polledRozmowa} />
			<RozmowaNextStepsSection rozmowa={polledRozmowa} />
		</>
	)
}
